module.exports = __webpack_public_path__ + "static/media/email-mbb.234255f2.svg";